import type { SxProps } from "@mui/material";

export const textLikeLinkStyles: SxProps = {
  color: "var(--link-color)",
};
